import { useThrottleEffect } from 'ahooks';
import { FC, useEffect, useState } from 'react';
import { useMemberTimeStore } from 'lowcode/utils/context/memberTimeZone';
import Questions from '../AppreciationDay/Questions';
import BenefitsNew from './BenefitsNew';
import ClockIn from './ClockIn';
import EcoAnchor from './EcoAnchor';
import EcoCreditRules2 from './EcoCreditRules2';
import EUEcoAnchorNew from './EUEcoAnchorNew';
import Faq2 from './Faq2';
import GrabEcoCreditsBonus from './GrabEcoCreditsBonus';
import HowItWorksNew from './HowItWorksNew';
import styled from './index.module.scss';
import JoinEcoclubNew from './JoinEcoclubNew';
import JoinEcoclubEU from './JoinEcoclubEU';
import LuckyTurntable from './LuckyTurntable';
import { LevelLogItem } from './type';
import WaysToEarnPointsNext from './WaysToEarnPointsNext';
import { eu11LocaleList, EU11TimeLineProd } from './config';
import getLocal from '@/app/utils/getLocal';
import QuestionsHistory from '@/components/AppreciationDay/Questions/History';
import CTACard from '@/components/EcoCredits/CommonElement/CTACard';
import EUFlashSale from '@/components/EcoCredits/CommonElement/EUFlashSale';
import EUFlashSale2 from '@/components/EcoCredits/CommonElement/EUFlashSale2';
import { EcoProvider } from '@/components/EcoCredits/context';
import DedicatedCustomer from '@/components/EcoCredits/DedicatedCustomer';
import FullScreenModal from '@/components/EcoCredits/FullScreenModal';
import LuckyHistory from '@/components/EcoCredits/LuckyTurntable/History';
import MixAppreciationDay from '@/components/EcoCredits/MixAppreciationDay';
import PointsActivity from '@/components/EcoCredits/PointsActivity';
import RewardsRedeemed from '@/components/EcoCredits/RewardsRedeemed';
import { injectNotes } from '@/components/EcoCredits/utils';
import { useMonthlyDispatch, useMonthlyStore } from '@/components/EcocreditsMonthlyMadness/MonthlyProvider';
import { ProductModule } from '@/components/EcocreditsMonthlyMadness/type';
import { euLocaleList, TimeLineProd } from '@/constants/appreciationDay';
import { useLang } from '@/i18n';
import {
    getDiscountCouponList,
    getIssuedCoupons,
    getLevelLogList,
    getRewardEarnRule,
    getRewardHistory,
    getRewardRuleList,
    getRewardsActivity,
    getRewardUserInfo,
    getRewardUserLevel,
} from '@/service/vip';

import BenefitPoint from '@/components/EcoCredits/BenefitPoint';
import BestOffers from '@/components/EcoCredits/CommonElement/EUBestOffers';
import EUProduct2 from '@/components/EcoCredits/CommonElement/EUProduct2';
import EcocreditsRuleAnnounce from '@/components/EcoCredits/EcocreditsRuleAnnounce';
import { IPageStatus } from '@/components/EcocreditsMonthlyMadness/type';

import { useGlobal } from '@/utils/useGlobal';

const EcoCreditsCompoment: FC = ({}) => {
    const { isLogin, rewardUserInfo, rewardUserLevel, pageStatus } = useMonthlyStore();
    const dispatch = useMonthlyDispatch();

    const { locale } = getLocal();
    const { t } = useLang('ecocredits');

    const [rewardEarnRule, setRewardEarnRule] = useState([]);
    const [issuedCoupon, setIssuedCoupon] = useState<any[]>([]);
    const [pointsActivity, setPointsActivity] = useState([]);
    const [rewardsActivity, setRewardsActivity] = useState([]);
    const [levelLogList, setLevelLogList] = useState<LevelLogItem[]>([]);
    const [discountCouponList, setDiscountCouponList] = useState<any[]>([]);
    const [firstIn, setFirstIn] = useState(true);
    const [showPage, setShowPage] = useState('basic'); // basic / history_modal / coupon_modal / points_modal / bouns_modal / qhistory_modal / lucky_history
    const [isShowEUProducts, setIsShowEUProducts] = useState(false);

    const timeLine = TimeLineProd[locale as string];

    const isEuWeekCompOrder = ['eu', 'uk', 'es', 'it', 'fr', 'de'].includes(locale) && pageStatus === IPageStatus.ACTIVITY;
    const hasRuleAnnounceList = ['us', 'ca', 'au', 'jp', 'kr', 'za'];
    const { useRouter, getSystemTime } = useGlobal();
    const time = getSystemTime();

    const isEuElevenCredits = ['eu', 'uk', 'es', 'it', 'fr', 'de'].includes(locale);
    const eu11timeLine = EU11TimeLineProd[locale as keyof typeof EU11TimeLineProd] || EU11TimeLineProd['eu'];

    const { timezoneList } = useMemberTimeStore();

    /**
     * 查询账户积分详情
     */
    const queryRewardUserInfo = async () => {
        const res = await getRewardUserInfo(locale as string);
        if (res?.code === '0') {
            dispatch({
                type: 'changeRewardUserInfo',
                payload: res.data || {},
            });
            return;
        }
    };

    /**
     * 查询账户权益等级
     */
    const queryRewardUserLevel = async () => {
        const ruleRes = await getRewardRuleList(locale as string);
        if (ruleRes?.code !== '0') return;
        if (!ruleRes.data) {
            return;
        }
        const plusMemberData = ruleRes.data.find((item) => item.level === 2);
        const memberData = ruleRes.data.find((item) => item.level === 1);
        const payload = {
            normalName: memberData?.name,
            plusName: plusMemberData?.name,
            minPoint: Number(plusMemberData?.minPoints),
        };

        if (isLogin) {
            const levelRes = await getRewardUserLevel(locale as string);
            // levelRes.data = {
            //     level: 2,
            //     validStartTime: '',
            //     validEndTime: '',
            // };
            if (levelRes?.code === '0' && levelRes.data) {
                const { level, validStartTime, validEndTime } = levelRes.data;
                const userLevelData = ruleRes.data.find((item) => item.level === level);

                Object.assign(payload, {
                    level,
                    validStartTime,
                    validEndTime,
                    name: userLevelData?.name || '',
                });
            }
        }
        dispatch({
            type: 'changeRewardUserLevel',
            payload,
        });
    };

    /**
     * 查询查询Rewards Activity 优惠券使用流水
     */
    const queryRewardsActivity = async () => {
        const res = await getRewardsActivity(locale as string);
        if (res?.code === '0') {
            setRewardsActivity(res.data?.content || []);
        }
    };

    /**
     * 查询查询升级日志
     */
    const queryLevelLogList = async () => {
        const res = await getLevelLogList(locale as string);
        if (res?.code === '0') {
            setLevelLogList(res.data || []);
        }
    };

    /**
     * 用户积分历史记录
     */
    const queryRewardHistory = async () => {
        const res = await getRewardHistory(locale as string);
        if (res?.code === '0') {
            setPointsActivity(res.data?.content || []);
        }
    };

    /**
     * 福利中心
     */
    const queryDiscountCouponList = async () => {
        const res = await getDiscountCouponList(locale as string);
        if (res?.code === '0') {
            const coupons = injectNotes(res.data, t, locale as string, timezoneList);
            setDiscountCouponList(coupons || []);
            const isHasUnUsedCoupons = coupons?.some((coupon: any) => coupon?.receiveStatus === 1 || !coupon?.receiveStatus);
            firstIn && isHasUnUsedCoupons && setShowPage('bouns_modal');
            setFirstIn(false);
        }
    };

    /**
     * 查询积分赚取规则列表
     */
    const queryRewardEarnRule = async () => {
        const res = await getRewardEarnRule(locale as string);
        if (res?.code === '0') {
            setRewardEarnRule(res.data || []);
        }
    };

    /**
     * 查询issued优惠券兑换记录
     */
    const queryIssuedRewards = async () => {
        const res = await getIssuedCoupons(locale as string);
        if (res?.code === '0') {
            const coupons = injectNotes(res?.data || [], t, locale as string, timezoneList);
            setIssuedCoupon(coupons || []);
        }
    };

    /**
     * 数据请求总和
     */
    const initData = () => {
        queryRewardUserLevel();
        if (!isLogin) return;
        queryRewardEarnRule();
        queryRewardUserInfo();
        queryIssuedRewards();
        queryDiscountCouponList();
        queryRewardsActivity();
        queryLevelLogList();
        queryRewardHistory();
    };

    /**
     * 刷新数据
     */
    const refershData = () => {
        queryRewardUserLevel();
        if (!isLogin) return;
        queryRewardUserInfo();
        queryRewardEarnRule();
    };

    const jumpView = () => {
        if (typeof window !== 'undefined') {
            // 因为需要等各组件请求数据回来之后 才能撑起组件高度 定位到对应位置 所以延后300ms执行
            setTimeout(() => {
                document.getElementById(window.location.hash.replace('#', ''))?.scrollIntoView({
                    behavior: 'smooth',
                });
            }, 300);
        }
    };

    const openModal = (key: string) => {
        setShowPage(key);
    };

    const closeModal = () => {
        setShowPage('basic');
    };

    useEffect(() => {
        if (locale && timeLine) {
            const time = new Date().getTime();
            const isActivityRange = time >= timeLine.activity.start && time < timeLine.activity.end;
            const isRequired = locale && euLocaleList.includes(locale) && isActivityRange;
            setIsShowEUProducts(!!isRequired);
        }
    }, [locale, timeLine]);

    useThrottleEffect(() => {
        initData();
        jumpView();
    }, []);

    const isEULocales = eu11LocaleList.includes(locale as string);
    const showEU11CheckIn = eu11timeLine.CheckIn.start <= time && time <= eu11timeLine.CheckIn.end;

    return (
        <>
            <style jsx global>
                {`
                    .ant-message {
                        z-index: 9999999;
                    }
                    .ant-modal-root {
                        z-index: 2102;
                    }
                    .ant-tooltip-inner {
                        white-space: pre-line;
                    }
                    body::-webkit-scrollbar {
                        width: 5px;
                    }
                    body::-webkit-scrollbar-thumb {
                        border-radius: 3px;
                        background: #ccc;
                    }
                `}
            </style>
            <EcoProvider>
                <div className={styled.ecocredits}>
                    {isEuWeekCompOrder ? (
                        <>
                            <JoinEcoclubEU openModal={openModal} refershData={refershData} />
                            {!isLogin && <div className="top-divider"></div>}
                            {hasRuleAnnounceList.includes(locale) && time <= new Date('2024/12/17 15:00:00 GMT+8').getTime() && (
                                <div style={!isLogin ? { marginTop: '40px' } : {}}>
                                    <EcocreditsRuleAnnounce />
                                </div>
                            )}
                            {/* <EUEcoAnchor /> */}
                            <div className="eu-common-container">
                                {/**  欧洲 11 月会员 */}
                                <EUEcoAnchorNew />
                                <BenefitPoint />
                                {/* <div id="Check_In">
                                    <ClockIn systemTime={time} />
                                </div> */}
                            </div>
                            {/* <EcoAnchor /> */}
                            {/* <div id="LUCKY_TURNTABLE1">
                                <CommonHeader title={t('eu_activity_nav_title1')} />
                                <LuckyTurntable isLogin={isLogin} setShowPage={setShowPage} refershData={refershData} />
                            </div>
                            <ProductSale
                                module={ProductModule.REFURBISH}
                                title={t('product_refurbished_title')}
                                desc={t('product_refurbished_desc')}
                            /> */}
                            <EUFlashSale2 module={ProductModule.FLASH_SALE} title={t('product_flash_title')} desc={t('product_flash_desc')} id={'FLASH_SALE'} />
                            <BestOffers
                                module={ProductModule.BEST_RECOMMEND}
                                title={t('product_bestoffer_title')}
                                desc={t('product_bestoffer_desc')}
                                id={'BEST_OFFERS'}
                            />
                            {/* <Questions isLogin={isLogin} setShowPage={setShowPage} refershData={refershData} scenario="active_eu" /> */}
                            <EUProduct2 module={ProductModule.HOT} title={t('product_hot_title')} desc={t('product_hot_desc')} id={'HOT_PICK'} />
                            <CTACard
                                title={t('card.title')}
                                subTitle={t('card.subtitle')}
                                cta={t('card.button')}
                                href={`https://www.ecoflow.com/${locale}/referral`}
                                pc={'https://websiteoss.ecoflow.com/upload/image/1731927697449/banner_pc.jpg'}
                                h5={'https://websiteoss.ecoflow.com/upload/image/1731927725532/banner_h5.jpg'}
                            />
                            {!isLogin && <HowItWorksNew />}
                            <BenefitsNew />
                            <WaysToEarnPointsNext isLogin={isLogin} rewardEarnRule={rewardEarnRule} refershData={refershData} />
                        </>
                    ) : (
                        <>
                            <JoinEcoclubNew openModal={openModal} refershData={refershData} />
                            {/* <JoinEcoclub isLogin={isLogin} rewardUserInfo={rewardUserInfo} openModal={openModal} refershData={refershData} /> */}
                            {hasRuleAnnounceList.includes(locale) && time <= new Date('2024/12/17 15:00:00 GMT+8').getTime() && (
                                <div style={!isLogin ? { marginTop: '40px' } : {}}>
                                    <EcocreditsRuleAnnounce />
                                </div>
                            )}

                            <EcoAnchor />
                            <ClockIn systemTime={time} />

                            {['kr', 'jp'].includes(locale as string) && (
                                <LuckyTurntable isLogin={isLogin} setShowPage={setShowPage} refershData={refershData} />
                            )}
                            {locale === 'jp' && <Questions isLogin={isLogin} setShowPage={setShowPage} refershData={refershData} />}
                            <MixAppreciationDay isLogin={isLogin} />
                            {isShowEUProducts && (
                                <>
                                    <EUFlashSale />
                                    {/* <PiecesProduct module={ProductModule.HOT} title={t('product_hot_title')} id={'HOT_PICK'} /> */}
                                </>
                            )}
                            {/* {whiteLocaleList.includes(locale as string) && <AppreciationDay />} */}
                            {!isLogin && <HowItWorksNew />}
                            {/* {!isLogin && <HowItWorks />} */}
                            <BenefitsNew />
                            {/* <Benefits isLogin={isLogin} isShowBtn={false} /> */}
                            {/* <WaysToEarnPoints isLogin={isLogin} rewardEarnRule={rewardEarnRule} refershData={refershData} /> */}
                            <WaysToEarnPointsNext isLogin={isLogin} rewardEarnRule={rewardEarnRule} refershData={refershData} />
                            {(locale === 'za' || locale === 'au') && <LuckyTurntable isLogin={isLogin} setShowPage={setShowPage} refershData={refershData} />}
                            {locale === 'jp' && isLogin && rewardUserLevel?.level === 2 && (
                                <div className="dedicated-modal-container">
                                    <DedicatedCustomer />
                                </div>
                            )}
                        </>
                    )}
                    <div id="ECOCREDIT_RULES" style={{ background: '#f5f5f5' }}>
                        <EcoCreditRules2
                            isLogin={isLogin}
                            subtitle={euLocaleList.includes(locale as string) ? t('redeem_ecocredits_title_next') : ''}
                            refershData={refershData}
                            rewardUserInfo={rewardUserInfo}
                            setShowPage={setShowPage}
                        />
                        {showPage?.startsWith('points_modal') && (
                            <FullScreenModal visible className={showPage} style={{ background: '#f5f5f5' }} closeModal={closeModal}>
                                <EcoCreditRules2
                                    modal
                                    isLogin={isLogin}
                                    refershData={refershData}
                                    rewardUserInfo={rewardUserInfo}
                                    setShowPage={setShowPage}
                                    defauleActiveTab={(showPage?.includes('$') && showPage?.split('$').pop()) || undefined}
                                />
                            </FullScreenModal>
                        )}
                    </div>
                    {/* <Faq /> */}
                    <Faq2 id="ECO_FAQ" />
                </div>

                {showPage?.startsWith('coupon_modal') && (
                    <FullScreenModal
                        visible={showPage?.startsWith('coupon_modal')}
                        className={showPage}
                        style={{ background: '#f8f8f8' }}
                        closeModal={closeModal}
                        afterOpen={() => {
                            queryIssuedRewards();
                        }}
                    >
                        <RewardsRedeemed modal defaultSelectKey={(showPage?.includes('$') && showPage?.split('$').pop()) || '1'} issuedCoupon={issuedCoupon} />
                    </FullScreenModal>
                )}

                {showPage === 'history_modal' && (
                    <FullScreenModal
                        visible={showPage === 'history_modal'}
                        className={showPage}
                        closeModal={closeModal}
                        afterOpen={() => {
                            queryRewardsActivity();
                            queryRewardHistory();
                            queryLevelLogList();
                        }}
                    >
                        <PointsActivity modal pointsActivity={pointsActivity} rewardsActivity={rewardsActivity} levelLogList={levelLogList} />
                    </FullScreenModal>
                )}
                <FullScreenModal
                    visible={showPage === 'bouns_modal'}
                    zIndex={1200}
                    className={`${showPage} top bouns_modal`}
                    closeModal={closeModal}
                    style={{ background: '#f5f5f5' }}
                    afterOpen={() => {
                        queryDiscountCouponList();
                    }}
                >
                    <GrabEcoCreditsBonus
                        coupons={discountCouponList}
                        setShowPage={setShowPage}
                        visible={showPage === 'bouns_modal'}
                        refershData={() => {
                            queryIssuedRewards();
                            queryDiscountCouponList();
                        }}
                    />
                </FullScreenModal>
                {showPage === 'qhistory_modal' && (
                    <FullScreenModal visible={showPage === 'qhistory_modal'} className={showPage} closeModal={() => setShowPage('basic')}>
                        <QuestionsHistory modal show={showPage === 'qhistory_modal'} />
                    </FullScreenModal>
                )}
                {showPage === 'lucky_history' && (
                    <FullScreenModal visible={showPage === 'lucky_history'} className={showPage} closeModal={() => setShowPage('basic')}>
                        <LuckyHistory showPage={showPage} />
                    </FullScreenModal>
                )}
            </EcoProvider>
        </>
    );
};

export default EcoCreditsCompoment;
